var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 5.02941H18.8889C19.0348 5.02941 19.1793 5.05832 19.3141 5.11448C19.4489 5.17065 19.5714 5.25298 19.6746 5.35676C19.7777 5.46054 19.8596 5.58375 19.9154 5.71935C19.9713 5.85495 20 6.00029 20 6.14706V17.8823C20 18.1788 19.8829 18.463 19.6746 18.6726C19.4662 18.8822 19.1836 19 18.8889 19H7.22222C6.92753 19 6.64492 18.8822 6.43655 18.6726C6.22818 18.463 6.11112 18.1788 6.11112 17.8823V15.6471H0.555548C0.48259 15.6471 0.410347 15.6326 0.342944 15.6045C0.27554 15.5764 0.214296 15.5353 0.162708 15.4834C0.111121 15.4315 0.0701996 15.3699 0.042282 15.3021C0.0143644 15.2343 -2.97339e-06 15.1616 4.61565e-10 15.0882V0.558838C-2.97339e-06 0.485452 0.0143644 0.412783 0.042282 0.344982C0.0701996 0.277181 0.111121 0.215575 0.162708 0.163681C0.214296 0.111788 0.27554 0.0706241 0.342944 0.0425395C0.410347 0.014455 0.48259 0 0.555548 0H15C15.073 0 15.1452 0.014455 15.2126 0.0425395C15.28 0.0706241 15.3413 0.111788 15.3928 0.163681C15.4444 0.215575 15.4853 0.277181 15.5133 0.344982C15.5412 0.412783 15.5556 0.485452 15.5555 0.558838V5.02941ZM15.5555 6.14706V15.0882C15.5556 15.1616 15.5412 15.2343 15.5133 15.3021C15.4853 15.3699 15.4444 15.4315 15.3928 15.4834C15.3413 15.5353 15.28 15.5764 15.2126 15.6045C15.1452 15.6326 15.073 15.6471 15 15.6471H7.22222V17.8823H18.8889V6.14706H15.5555ZM14.4445 5.02941V1.11765H1.11112V14.5294H14.4445V5.02941Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.e22239b61ff73571fc0f6f1a02361011.svg";
export { ForwardRef as ReactComponent };